import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/authentication/_services/auth.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { PricingPageComponent } from '../pricing-page/pricing-page.component';
import { PricingModalComponent } from '../pricing-modal/pricing-modal.component';
import { PricingService } from 'src/app/services/pricing.service';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LanguageFlag } from '../language-selector-front-end/language-selector-front-end.component';
import { TranslationService } from 'src/app/shared/i18n/translation.service';

@Component({
    selector: 'app-header-style-two-user',
    templateUrl: './header-style-two-user.component.html',
    styleUrls: ['./header-style-two-user.component.scss'],
    standalone: false
})
export class HeaderStyleTwoUserComponent implements OnInit {

  constructor(private modalService: NgbModal, private router: Router
      , public authService: AuthenticationService, public pricingService: PricingService, private translationService: TranslationService,
  ) { }
  userName: string | null = null;
  token: string | null = null;
  packagesCount: number = 0;
  isLoading: boolean;
  ngOnInit(): void {
      this.setSelectedLanguage();
      this.router.events
          .pipe(filter((event) => event instanceof NavigationStart))
          .subscribe((event) => {
              this.setSelectedLanguage();
          });
  }

  classApplied = false;
  toggleClass() {
      this.classApplied = !this.classApplied;
  }

  classApplied2 = false;
  toggleClass2() {
      this.classApplied2 = !this.classApplied2;
  }

  classApplied3 = false;
  toggleClass3() {
      this.classApplied3 = !this.classApplied3;
  }
  logout() {

      this.authService.logout();
  }
  choosePackage() {
      const modalRef = this.modalService.open(PricingModalComponent, { size: 'xl' });
      modalRef.result.then(() =>
          () => {
              this.isLoading = false

          }
      );
  }
 
  language: LanguageFlag = new LanguageFlag();
  setLanguageWithRefresh(lang: any) {
      this.setLanguage(lang);
      document.documentElement.setAttribute('lang', 'de');
      window.location.reload();
  }
  setLanguage(lang: any) {
      this.languages.forEach((language: LanguageFlag) => {
          if (language.lang === lang) {
              language.active = true;
              this.language = language;
          } else {
              language.active = false;
          }
      });
      this.translationService.setLanguage(lang);
  }
  languages: LanguageFlag[] = [
      {
          lang: 'en',
          name: 'En',
          flag: './assets/img/us-flag.jpg',
      },
      {
          lang: 'de',
          name: 'Ger',
          flag: './assets/img/germany-flag.jpg',
      }
  ];
  setSelectedLanguage(): any {
      this.setLanguage(this.translationService.getSelectedLanguage());
  }
}